import { Card, Col } from "reactstrap";
import SMSHeader from "../sms-header/SMSHeader";
import SentContent from "./SentContent";
import { SMSData } from "../types/types";

interface SMSRightSideProps {
  composeSMS: boolean;
  setComposeSMS: (value: boolean) => void;
  smsValidation: boolean;
  setSMSValidation: (value: boolean) => void;
  searchWord: string;
  setSearchWord: (value: string) => void;
  smsMessages: SMSData[];
  handleAddSMS: (newSMS: {
    recipientRoles: string;
    message: string;
    description: string;
  }) => void;
}

const SMSRightSide: React.FC<SMSRightSideProps> = ({
  composeSMS,
  setComposeSMS,
  smsValidation,
  setSMSValidation,
  searchWord,
  setSearchWord,
  smsMessages,
  handleAddSMS,
}) => {
  return (
    <Col xxl="12">
      <div className="email-right-aside">
        <Card className="email-body email-list">
          <SMSHeader
            searchWord={searchWord}
            setSearchWord={setSearchWord}
            setComposeSMS={setComposeSMS}
          />
          <SentContent smsMessages={smsMessages} searchWord={searchWord} />
        </Card>
      </div>
    </Col>
  );
};

export default SMSRightSide;
